'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATUS_TO_USERTYPE = exports.COOKIE_NAME = exports.set = exports.get = exports.setFromProfile = exports.getUserTypeFromProfile = exports.sanitizeUserType = exports.isValidUserType = undefined;

var _cookies = require('redux/saga/helpers/cookies');

var COOKIE_NAME = 'cpUserType';

var isValidUserType = exports.isValidUserType = function isValidUserType(type) {
  return ['prospect', 'lead', 'churned', 'subscribed', 'registered'].includes(type);
};

var sanitizeUserType = exports.sanitizeUserType = function sanitizeUserType(type) {
  return isValidUserType(type) ? type : '';
};

var STATUS_TO_USERTYPE = {
  cancelled: 'churned',
  active: 'subscribed',
  unsubscribed: 'registered'
};

var get = function get() {
  return (0, _cookies.getCookie)(COOKIE_NAME, 'prospect');
};

var set = function set(userType) {
  return (0, _cookies.setCookie)(COOKIE_NAME, userType, {
    path: '/',
    expires: new Date(2024, 0, 1)
  });
};

var getUserTypeFromProfile = exports.getUserTypeFromProfile = function getUserTypeFromProfile(profile) {
  if (profile && profile.membership) {
    return STATUS_TO_USERTYPE[profile.membership.status];
  }
};

var setFromProfile = function setFromProfile(profile) {
  var userType = getUserTypeFromProfile(profile);
  if (userType) {
    set(userType);
  }
};

exports.setFromProfile = setFromProfile;
exports.get = get;
exports.set = set;
exports.COOKIE_NAME = COOKIE_NAME;
exports.STATUS_TO_USERTYPE = STATUS_TO_USERTYPE;